import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { ProjectScheduleGridResponse, ScheduleQueryOptions } from '../lib/types';

export function useProjectSchedule(options: ScheduleQueryOptions) {
  const params = new URLSearchParams();
  params.set('from', options.from);
  params.set('to', options.to);
  if (options.region) params.set('region', options.region);
  if (options.office) params.set('office', options.office);
  if (options.serviceLine) params.set('serviceLine', options.serviceLine);
  for (const id of options.personIds ?? []) params.append('personIds', String(id));
  for (const id of options.projectIds ?? []) params.append('projectIds', String(id));

  return useQuery({
    queryKey: ['project-schedule', options],
    queryFn: () => apiClient.get<ProjectScheduleGridResponse>(`/api/schedule/projects?${params}`),
    enabled: !!options.from && !!options.to,
  });
}
